import { render } from "./wishList.vue?vue&type=template&id=399cb4eb"
import script from "./wishList.vue?vue&type=script&lang=js"
export * from "./wishList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__